import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const CircleHalfFullIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1024 128q124 0 238 32t214 90 181 140 140 181 91 214 32 239q0 124-32 238t-90 214-140 181-181 140-214 91-239 32q-124 0-238-32t-214-90-181-140-140-181-91-214-32-239q0-124 32-238t90-214 140-181 181-140 214-91 239-32zm0 128q-106 0-204 27t-183 78-156 120-120 155-77 184-28 204h1536q0-106-27-204t-78-183-120-156-155-120-184-77-204-28z" />
    </svg>
  ),
  displayName: 'CircleHalfFullIcon',
});

export default CircleHalfFullIcon;
